"use strict";

var PyDefUtils = require("PyDefUtils");

module.exports = function(pyModule) {

    pyModule["DesignImage"] = Sk.misceval.buildClass(pyModule, function($gbl, $loc) {

        $loc["__init__"] = new Sk.builtin.func(PyDefUtils.withRawKwargs(function(kwargs, self) {
            Sk.misceval.call(pyModule["Image"].prototype["__init__"], undefined, undefined, kwargs, self);

            var img = self._anvil.element.find("img");
            img.on("load", function() {
                if (PyDefUtils.updateHeight)
                    PyDefUtils.updateHeight();
            });
            
            PyDefUtils.addHeightHandle(self._anvil);
            let getHeightHandle = self._anvil.getHandles;
            self._anvil.getHandles = () => self._anvil.isSelfSizing ? [] : getHeightHandle();
        }));

    }, 'DesignImage', [pyModule["Image"]]);
};
